// extracted by mini-css-extract-plugin
export default {"container":"text_container__2nFGz","medium":"text_medium__2TJKo"};